"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "../button";
import Modal from "../custom-modal";
import { Check } from "lucide-react";

interface Props {
  description?: string;
  onClose: () => void;
  open: boolean;
  text?: string;
}

const SuccessModal: React.FC<Props> = ({
  description,
  onClose,
  open,
  text = "بستن",
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <Modal
      isOpen={open}
      onClose={onClose}
      className="w-100 h-81"
      animate={false}
      fullScreenOnMobile={false}
    >
      <div className="flex flex-col gap-4 w-full items-center">
        <div
          className="
      bg-[#12B76A] rounded-[50%] p-2 
      flex justify-center items-center
      w-16 h-16 mb-4
      "
        >
          <Check className="scale-200 text-white" />
        </div>

        <h5 className="font-semibold text-sec-title">موفق!</h5>

        <p className="text-description">{description}</p>

        <Button
          type="button"
          text={text}
          onClick={onClose}
          className="w-full bg-[#12B76A] text-white"
        />
      </div>
    </Modal>,
    document.body,
  );
};

export default SuccessModal;
